/* eslint-disable node/no-missing-import */
// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Input from '@salesforce/design-system-react/components/input';
import Textarea from '@salesforce/design-system-react/components/textarea';
import Button from '@salesforce/design-system-react/components/button';
import { useIntl } from 'react-intl';
import { LABEL_AES_KEY, LABEL_CANCEL, LABEL_KEY_ID, LABEL_KEY_ID_LONG, LABEL_RESTORE, LABEL_RSA_KEY } from '../../constants/constants';

function RestoreRequest ({ ...props }) {
	const [keyId, setKeyId] = useState('');
	const [aesWrappingKey, setAesWrappingKey] = useState('');
	const [wrappedRsaKeyValue, setWrappedRsaKeyValue] = useState('');
	const intl = useIntl();

	const { changeToRestoreTokenValidationPage, processRestoreRequest, accessToken, userInfo } = props;

	const createRestoreRequestPayload = () => ({
		restoreToken: accessToken,
		keyId,
		wrappedAesBytes: aesWrappingKey,
		wrappedRsaBytes: wrappedRsaKeyValue,
		eid: userInfo.eid,
		mid: userInfo.mid
	});

	const sendRestoreRequest = () => {
		const resuestPayload = createRestoreRequestPayload();
		processRestoreRequest(resuestPayload);
	};

	const keyIdLabel = intl.formatMessage({
		id: 'labels.KEY_ID',
		defaultMessage: LABEL_KEY_ID
	});

	const keyIdLongLabel = intl.formatMessage({
		id: 'labels.KEY_ID_LONG',
		defaultMessage: LABEL_KEY_ID_LONG
	});

	const aesKeyLabel = intl.formatMessage({
		id: 'labels.WRAPPED_AES_KEY',
		defaultMessage: LABEL_AES_KEY
	});

	const rsaKeyLabel = intl.formatMessage({
		id: 'labels.WRAPPED_RSA_KEY',
		defaultMessage: LABEL_RSA_KEY
	});

	const cancelLabel = intl.formatMessage({
		id: 'labels.CANCEL',
		defaultMessage: LABEL_CANCEL
	});

	const restoreLabel = intl.formatMessage({
		id: 'labels.RESTORE',
		defaultMessage: LABEL_RESTORE
	});

	return (
		<div className="slds-grid slds-wrap  slds-align_absolute-center">
			<div className="slds-col slds-medium-size_5-of-12">
				<div className="slds-card">
					<div className="slds-p-around_medium">
						<div className="slds-size_1-of-1">
							<Input
								id="key-id"
								label={keyIdLabel}
								placeholder={keyIdLongLabel}
								maxLength="100"
								required
								// errorText={this.state.validationErrors.KeyName}
								onChange={(e) => setKeyId(e.target.value)}
							/>
						</div>
						<div className="slds-size_1-of-1">
							<Textarea
								id="aesWrappingKey"
								name="wrapped-aes-wrapping-key"
								label={aesKeyLabel}
								placeholder={aesKeyLabel}
								required
								// errorText={this.state.validationErrors.WrappedAesBytes}
								// onChange={this.handleWrappedAesKeyValueChanges}
								onChange={(e) => setAesWrappingKey(e.target.value)}
							/>
						</div>
						<div className="slds-size_1-of-1">
							<Textarea
								id="wrappedRsaKeyValue"
								name="wrapped-rsa-key-value"
								label={rsaKeyLabel}
								placeholder={rsaKeyLabel}
								required
								// errorText={this.state.validationErrors.WrappedRsaBytes}
								onChange={(e) => setWrappedRsaKeyValue(e.target.value)}
							/>
						</div>
						<div className="slds-size-medium_5-of-12 slds-clearfix">
							<div className="slds-size_1-of-3 slds-float_left">
								<Button label={cancelLabel} className="max-width" onClick={changeToRestoreTokenValidationPage} />
							</div>
							<div className="slds-size_1-of-3 slds-float_right">
								<Button label={restoreLabel} className="max-width" variant="brand" onClick={sendRestoreRequest} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

RestoreRequest.propTypes = {
	changeToRestoreTokenValidationPage: PropTypes.func.isRequired,
	changeToRestoreResponsePage: PropTypes.func.isRequired,
	processRestoreRequest: PropTypes.func.isRequired,
	accessToken: PropTypes.string.isRequired,
	userInfo: PropTypes.object.isRequired
};

export default RestoreRequest;
